import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  activateChangeProgramCampusModalityUseCase,
  activatePayOrderUseCase,
  activatePaymentCertificateOfStudies,
  activatePaymentReincorporationUseCase,
  activateRegisterCarnetUseCase,
  breadcrumbUseCase,
  cancelChangeProgramCampusModalityUseCase,
  cancelRegisterCarnetUseCase,
  cancelReservationUseCase,
  cancelUpdatePhotoUseCase,
  deleteFileBseUseCase,
  downloadDocumentUseCase,
  filterByWeekUseCase,
  getAcademicCalendarUseCase,
  getAcademicDatesUseCase,
  getAcademicPlanProgress,
  getActivitiesUseCase,
  getBannerList,
  getCampusByModalityUseCase,
  getPeriodsWithDebtsUseCase,
  getCampusTabletsUseCase,
  getCoursesWithReinforcements,
  getCoursesGradeRecord,
  getCurrentPeriodUseCase,
  getDatesLibraryUseCase,
  getEventDetail,
  getEventsByStudent,
  getExamsUseCase,
  getFormBse,
  getLinksInterest,
  getModalityOptionListUseCase,
  getPlanProgressDetail,
  getPlanProgressEquivalences,
  getPlanProgressResume,
  getPlanProgressPS,
  getProcedureInformation,
  getProceduresByStudent,
  getProceduresCategoryUseCase,
  getProceduresCreated,
  getProceduresNotAutomatedUseCase,
  getProfessorsUseCase,
  getProfilePhotoUseCase,
  getProfileTurnUseCase,
  getProfileUseCase,
  getProfileDataUseCase,
  getProfileMastersDataUseCase,
  getProgramByCampusUseCase,
  getReinforcementDetail,
  getReinforcementUseCase,
  getReinforcementsByCourse,
  getReservationDetailUseCase,
  getScheduleByDay,
  getScheduleGoToWeekUseCase,
  getScheduleOnlyUseCase,
  getScheduleSelectDateUseCase,
  getScheduleUseCase,
  getStateBseUseCase,
  getStatusResourceUseCase,
  getStudentInformation,
  getStudentPortalSettingsUseCase,
  getStudentProcedureStatus,
  getStudentSimulated,
  getSubscribedsTabletsUseCase,
  getUrlDocumentUseCase,
  getWeekUseCase,
  getYearsOfProcedures,
  getVersionUseCase,
  modalityOfStudy,
  processFormBse,
  programByCampus,
  registerBseUseCase,
  registerCarnetUseCase,
  registerCertificateOfStudies,
  registerChangeProgramCampusModalityUseCase,
  registerChangeUseCase,
  registerReincorporation,
  registerRemoveFromPeriodUseCase,
  registerTicketNotAutomatedUseCase,
  registerUpdatePhotoUseCase,
  selectAcademicDateUseCase,
  sendValidationCodeUseCase,
  setEventInscription,
  setEventUnsubscribe,
  signInUseCase,
  signOutUseCase,
  subscribeResourceUseCase,
  subscribeToReinforcement,
  unsubscribeToReinforcement,
  updateDataProfileUseCase,
  updateProfileUseCase,
  uploadDocumentBse,
  validateUserUseCase,
  getPeriodCourses,
  getSummaryCourses,
  getPeriodsUseCase,
  getEnrolmentApptByPeriodUseCase,
  validateCodeByTypeUseCase,
  getLateCourses,
  registerLateCourses,
  activatePaymentLateCourses,
  registerChangePhotoUseCase,
  registerWithdrawalCoursesUseCases,
  activateWithdrawalCourse,
  getEmailAndPhoneUseCase,
  getStudentType,
  getScheduleResumeHome,
  getPayments,
  getPaymentBanks,
  getPendingPayments,
  getPaidPayments,
  getPaymentPeriods,
  getPaymentsByPeriod,
  getBenefitInstallments,
  getBenefitInstallmentsInfo,
  activateBenefitInstallments,
  getPaymentVouchers,
  generatePaymentVoucher,
  generatePaymentVoucherLateFee,
  createOrder,
  payOrder,
  getCaptcha,
  registerInsuranceValidation,
  getClassAttendanceUseCase,
  getEventsByStudentScroll,
  registerEmployabilityCharter,
  getSurveysValidation,
  getEnrollmentCourses,
  getRegistrationTimes,
  getEvaluationsToBeCorrected,
  RegisterRectificationOfGrade,
  getProgressiveCertificationEnabled,
  uploadValidation,
  registerWaitingList,
  eventPenalties,
  examsRoleByStudent,
  unregisterWaitingList,
  getUtpAdsDataUseCase,
  getInstitutionalInformation,
  getScholarshipsDiscounts,
  getAgreementInfo,
  registerAgreement,
  getAgreementValidations,
  paymentsStatusVerification,
  registerReinforcementWaitingListUseCase,
  unregisterReinforcementWaitingListUseCase,
  getProfileAcl,
  getOrganizer
} from '../useCases';

export default function* rootSaga() {
  yield takeLatest(signInUseCase.Types.SIGN_IN, signInUseCase.saga);
  yield takeLatest(signOutUseCase.Types.SIGN_OUT, signOutUseCase.saga);
  yield takeLatest(
    validateUserUseCase.Types.VALIDATE_USER_TOKEN,
    validateUserUseCase.saga
  );
  yield takeLatest(getProfileUseCase.Types.GET_PROFILE, getProfileUseCase.saga);
  yield takeLatest(
    getProfileDataUseCase.Types.GET_PROFILE_DATA,
    getProfileDataUseCase.saga
  );
  yield takeLatest(
    getProfilePhotoUseCase.Types.GET_PROFILE_PHOTO,
    getProfilePhotoUseCase.saga
  );
  yield takeLatest(
    getScheduleUseCase.Types.GET_SCHEDULE,
    getScheduleUseCase.saga
  );
  yield takeLatest(
    registerCarnetUseCase.Types.REGISTER_CARNET,
    registerCarnetUseCase.saga
  );
  yield takeLatest(
    cancelRegisterCarnetUseCase.Types.CANCEL_REGISTER_CARNET,
    cancelRegisterCarnetUseCase.saga
  );
  yield takeLatest(
    getScheduleGoToWeekUseCase.Types.GO_TO_SPECIFIC_WEEK,
    getScheduleGoToWeekUseCase.saga
  );
  yield takeLatest(
    getScheduleSelectDateUseCase.Types.SELECT_DATE,
    getScheduleSelectDateUseCase.saga
  );
  yield takeLatest(
    getAcademicCalendarUseCase.Types.GET_ACADEMIC_CALENDAR,
    getAcademicCalendarUseCase.saga
  );
  yield takeLatest(
    getAcademicDatesUseCase.Types.GET_ACADEMIC_DATES,
    getAcademicDatesUseCase.saga
  );
  yield takeLatest(
    getPlanProgressDetail.Types.GET_PLAN_PROGRESS_DETAIL,
    getPlanProgressDetail.saga
  );
  yield takeLatest(
    getPlanProgressEquivalences.Types.GET_PLAN_PROGRESS_EQUIVALENCES,
    getPlanProgressEquivalences.saga
  );
  yield takeLatest(
    getPlanProgressResume.Types.GET_PLAN_PROGRESS_RESUME,
    getPlanProgressResume.saga
  );
  yield takeLatest(
    getPlanProgressPS.Types.GET_PLAN_PROGRESS_PS,
    getPlanProgressPS.saga
  );
  yield takeLatest(
    getProcedureInformation.Types.GET_PROCEDURE_INFORMATION,
    getProcedureInformation.saga
  );
  yield takeLatest(
    getStudentInformation.Types.GET_STUDENT_INFORMATION,
    getStudentInformation.saga
  );
  yield takeLatest(
    getProceduresByStudent.Types.GET_PROCEDURES_BY_STUDENT,
    getProceduresByStudent.saga
  );
  yield takeLatest(
    getStudentProcedureStatus.Types.GET_STUDENT_PROCEDURE_STATUS,
    getStudentProcedureStatus.saga
  );
  yield takeLatest(
    getProceduresCategoryUseCase.Types.GET_PROCEDURES_CATEGORY,
    getProceduresCategoryUseCase.saga
  );
  yield takeLatest(
    activatePaymentCertificateOfStudies.Types.ACTIVATE_CERTIFICATE_OF_STUDIES,
    activatePaymentCertificateOfStudies.saga
  );
  yield takeLatest(
    paymentsStatusVerification.Types.PAYMENTS_VERIFICATION_PROCEDURE,
    paymentsStatusVerification.saga
  );
  yield takeLatest(
    registerCertificateOfStudies.Types.REGISTER_CERTIFICATE_OF_STUDIES,
    registerCertificateOfStudies.saga
  );
  yield takeLatest(
    registerUpdatePhotoUseCase.Types.REGISTER_UPDATE_PHOTO,
    registerUpdatePhotoUseCase.saga
  );
  yield takeLatest(
    cancelUpdatePhotoUseCase.Types.CANCEL_UPDATE_PHOTO,
    cancelUpdatePhotoUseCase.saga
  );
  yield takeLatest(
    registerRemoveFromPeriodUseCase.Types.REGISTER_RETIREMENT_OF_PERIOD,
    registerRemoveFromPeriodUseCase.saga
  );
  yield takeLatest(
    selectAcademicDateUseCase.Types.SELECT_ACADEMIC_DATE,
    selectAcademicDateUseCase.saga
  );
  yield takeLatest(
    downloadDocumentUseCase.Types.DOWNLOAD_FILE,
    downloadDocumentUseCase.saga
  );
  yield takeLatest(
    registerChangeProgramCampusModalityUseCase.Types
      .REGISTER_CHANGE_PROGRAM_CAMPUS_MODALITY,
    registerChangeProgramCampusModalityUseCase.saga
  );
  yield takeLatest(
    activateChangeProgramCampusModalityUseCase.Types
      .ACTIVATE_CHANGE_PROGRAM_CAMPUS_MODALITY,
    activateChangeProgramCampusModalityUseCase.saga
  );
  yield takeLatest(
    getCampusByModalityUseCase.Types.GET_CAMPUS_BY_MODALITY,
    getCampusByModalityUseCase.saga
  );
  yield takeLatest(
    getProgramByCampusUseCase.Types.GET_PROGRAM_BY_CAMPUS,
    getProgramByCampusUseCase.saga
  );
  yield takeLatest(
    cancelChangeProgramCampusModalityUseCase.Types
      .CANCEL_CHANGE_PROGRAM_CAMPUS_MODALITY,
    cancelChangeProgramCampusModalityUseCase.saga
  );
  yield takeLatest(
    activateRegisterCarnetUseCase.Types.ACTIVATE_CARNET_UNIVERSITY,
    activateRegisterCarnetUseCase.saga
  );
  yield takeLatest(
    getCurrentPeriodUseCase.Types.GET_CURRENT_PERIOD,
    getCurrentPeriodUseCase.saga
  );
  yield takeLatest(
    getScheduleOnlyUseCase.Types.GET_SCHEDULE_ONLY,
    getScheduleOnlyUseCase.saga
  );
  yield takeLatest(
    getActivitiesUseCase.Types.GET_ACTIVITIES,
    getActivitiesUseCase.saga
  );
  yield takeLatest(getWeekUseCase.Types.GET_WEEK, getWeekUseCase.saga);
  yield takeLatest(
    filterByWeekUseCase.Types.FILTER_BY_WEEK,
    filterByWeekUseCase.saga
  );
  yield takeLatest(
    getProfessorsUseCase.Types.GET_PROFESSORS,
    getProfessorsUseCase.saga
  );
  yield takeLatest(
    getReinforcementUseCase.Types.GET_REINFORCEMENT,
    getReinforcementUseCase.saga
  );
  yield takeLatest(getExamsUseCase.Types.GET_EXAMS, getExamsUseCase.saga);
  yield takeLatest(
    getProceduresNotAutomatedUseCase.Types.GET_PROCEDURES_NOT_AUTOMATED,
    getProceduresNotAutomatedUseCase.saga
  );
  yield takeLatest(
    getProceduresCreated.Types.GET_PROCEDURES_CREATED,
    getProceduresCreated.saga
  );
  yield takeLatest(
    registerTicketNotAutomatedUseCase.Types.REGISTER_TICKET,
    registerTicketNotAutomatedUseCase.saga
  );
  yield takeLatest(createOrder.Types.CREATE_ORDER, createOrder.saga);
  yield takeLatest(payOrder.Types.PAY_ORDER, payOrder.saga);
  yield takeLatest(
    getYearsOfProcedures.Types.GET_YEARS_OF_PROCEDURES,
    getYearsOfProcedures.saga
  );
  yield takeLatest(
    breadcrumbUseCase.Types.SET_POSITION,
    breadcrumbUseCase.saga
  );
  yield takeLatest(
    getScheduleByDay.Types.GET_SCHEDULE_BY_DAY,
    getScheduleByDay.saga
  );
  yield takeLatest(
    getStudentSimulated.Types.GET_STUDENT_BY_ID,
    getStudentSimulated.saga
  );
  yield takeLatest(
    getEventsByStudent.Types.GET_EVENTS_BY_STUDENT,
    getEventsByStudent.saga
  );
  yield takeLatest(getEventDetail.Types.GET_EVENT_DETAIL, getEventDetail.saga);
  yield takeLatest(
    getReinforcementDetail.Types.GET_REINFORCEMENT_DETAIL,
    getReinforcementDetail.saga
  );
  yield takeLatest(
    setEventInscription.Types.SET_EVENT_INSCRIPTION,
    setEventInscription.saga
  );
  yield takeLatest(
    setEventUnsubscribe.Types.SET_EVENT_UNSUBSCRIBE,
    setEventUnsubscribe.saga
  );
  yield takeLatest(
    subscribeToReinforcement.Types.SUBSCRIBE_TO_REINFORCEMENT,
    subscribeToReinforcement.saga
  );
  yield takeLatest(
    unsubscribeToReinforcement.Types.UNSUBSCRIBE_TO_REINFORCEMENT,
    unsubscribeToReinforcement.saga
  );
  yield takeLatest(
    getReinforcementsByCourse.Types.GET_REINFORCEMENTS_BY_COURSE,
    getReinforcementsByCourse.saga
  );
  yield takeLatest(
    getCoursesWithReinforcements.Types.GET_COURSES_WITH_REINFORCEMENTS,
    getCoursesWithReinforcements.saga
  );
  yield takeLatest(getFormBse.Types.GET_FORM_BSE, getFormBse.saga);

  yield takeLatest(
    registerBseUseCase.Types.REGISTER_BSE,
    registerBseUseCase.saga
  );

  yield takeLatest(processFormBse.Types.PROCESS_FORM_BSE, processFormBse.saga);

  yield takeLatest(
    deleteFileBseUseCase.Types.DELETE_FILE_BSE,
    deleteFileBseUseCase.saga
  );

  yield takeLatest(
    getStudentPortalSettingsUseCase.Types.GET_STUDENT_PORTAL_SETTINGS,
    getStudentPortalSettingsUseCase.saga
  );

  yield takeLatest(getVersionUseCase.Types.GET_VERSION, getVersionUseCase.saga);

  yield takeLatest(getBannerList.Types.GET_BANNER_LIST, getBannerList.saga);
  yield takeLatest(
    registerChangeUseCase.Types.REGISTER_CHANGE,
    registerChangeUseCase.saga
  );
  yield takeLatest(
    modalityOfStudy.Types.GET_MODALITY_OF_STUDY,
    modalityOfStudy.saga
  );
  yield takeLatest(
    getLinksInterest.Types.GET_LINKS_INTEREST,
    getLinksInterest.saga
  );
  yield takeLatest(
    getProfileTurnUseCase.Types.GET_PROFILE_TURN,
    getProfileTurnUseCase.saga
  );
  yield takeLatest(
    getProfileMastersDataUseCase.Types.GET_PROFILE_MASTERS_DATA,
    getProfileMastersDataUseCase.saga
  );
  yield takeLatest(
    getAcademicPlanProgress.Types.GET_ACADEMIC_PLAN_PROGRESS,
    getAcademicPlanProgress.saga
  );
  yield takeLatest(
    uploadDocumentBse.Types.UPLOAD_BSE_DOCUMENT,
    uploadDocumentBse.saga
  );
  yield takeLatest(
    activatePayOrderUseCase.Types.ACTIVATE_PAY_ORDER,
    activatePayOrderUseCase.saga
  );
  yield takeLatest(
    getStateBseUseCase.Types.GET_STATE_BSE,
    getStateBseUseCase.saga
  );
  yield takeLatest(
    getUrlDocumentUseCase.Types.GET_URL_DOCUMENT,
    getUrlDocumentUseCase.saga
  );
  yield takeLatest(
    getModalityOptionListUseCase.Types.GET_MODALITY_OPTION_LIST,
    getModalityOptionListUseCase.saga
  );
  yield takeLatest(
    getCampusTabletsUseCase.Types.GET_CAMPUS_TABLETS,
    getCampusTabletsUseCase.saga
  );
  yield takeLatest(
    getDatesLibraryUseCase.Types.GET_DATES_LIBRARY,
    getDatesLibraryUseCase.saga
  );
  yield takeLatest(
    subscribeResourceUseCase.Types.SUBSCRIBE_RESOURCE,
    subscribeResourceUseCase.saga
  );
  yield takeLatest(
    getReservationDetailUseCase.Types.GET_RESERVATION_DETAIL,
    getReservationDetailUseCase.saga
  );
  yield takeLatest(
    cancelReservationUseCase.Types.CANCEL_RESERVATION,
    cancelReservationUseCase.saga
  );

  yield takeLatest(
    getSubscribedsTabletsUseCase.Types.GET_SUBSCRIBEDS_TABLETS,
    getSubscribedsTabletsUseCase.saga
  );

  yield takeLatest(
    getStatusResourceUseCase.Types.GET_STATUS_RESOURCE,
    getStatusResourceUseCase.saga
  );

  yield takeLatest(
    registerReincorporation.Types.REGISTER_REINCORPORATION,
    registerReincorporation.saga
  );

  yield takeLatest(
    programByCampus.Types.PROGRAM_BY_CAMPUS,
    programByCampus.saga
  );

  yield takeLatest(
    activatePaymentReincorporationUseCase.Types.ACTIVATE_PAYMENT,
    activatePaymentReincorporationUseCase.saga
  );

  yield takeLatest(
    sendValidationCodeUseCase.Types.SEND_VALIDATION_CODE,
    sendValidationCodeUseCase.saga
  );

  yield takeLatest(
    updateDataProfileUseCase.Types.UPDATE_DATA_PROFILE,
    updateDataProfileUseCase.saga
  );
  yield takeLatest(
    updateProfileUseCase.Types.UPDATE_PROFILE,
    updateProfileUseCase.saga
  );
  yield takeLatest(
    getPeriodCourses.Types.GET_COURSE_PERIOD,
    getPeriodCourses.saga
  );
  yield takeLatest(
    getSummaryCourses.Types.GET_COURSE_SUMMARY,
    getSummaryCourses.saga
  );

  yield takeLatest(getPeriodsUseCase.Types.GET_PERIODS, getPeriodsUseCase.saga);
  yield takeLatest(
    getEnrolmentApptByPeriodUseCase.Types.GET_PROFILE_TURN_BY_PERIOD,
    getEnrolmentApptByPeriodUseCase.saga
  );

  yield takeLatest(
    validateCodeByTypeUseCase.Types.VALIDATE_CODE_BY_TYPE,
    validateCodeByTypeUseCase.saga
  );
  yield takeLatest(getLateCourses.Types.GET_LATE_COURSES, getLateCourses.saga);
  yield takeLatest(
    registerLateCourses.Types.REGISTER_LATE_COURSES,
    registerLateCourses.saga
  );
  yield takeLatest(
    activatePaymentLateCourses.Types.ACTIVATE_PAYMENT_COURSES,
    activatePaymentLateCourses.saga
  );
  yield takeLatest(
    registerChangePhotoUseCase.Types.REGISTER_CHANGE_PHOTO,
    registerChangePhotoUseCase.saga
  );
  yield takeLatest(
    registerWithdrawalCoursesUseCases.Types.REGISTER_WITHDRAWAL_COURSES,
    registerWithdrawalCoursesUseCases.saga
  );
  yield takeLatest(
    activateWithdrawalCourse.Types.ACTIVATE_WITHDRAWAL_COURSES,
    activateWithdrawalCourse.saga
  );
  yield takeLatest(
    getEmailAndPhoneUseCase.Types.GET_EMAIL_AND_PHONE,
    getEmailAndPhoneUseCase.saga
  );
  yield takeLatest(getStudentType.Types.GET_STUDENT_TYPE, getStudentType.saga);
  yield takeLatest(
    getScheduleResumeHome.Types.GET_SCHEDULE_RESUME,
    getScheduleResumeHome.saga
  );
  yield takeLatest(getPayments.Types.GET_PAYMENTS, getPayments.saga);
  yield takeLatest(
    getPaymentBanks.Types.GET_PAYMENT_BANKS,
    getPaymentBanks.saga
  );
  yield takeLatest(
    getPendingPayments.Types.GET_PENDING_PAYMENTS,
    getPendingPayments.saga
  );
  yield takeLatest(
    getBenefitInstallments.Types.GET_BENEFIT_INSTALLMENTS,
    getBenefitInstallments.saga
  );
  yield takeLatest(
    getBenefitInstallmentsInfo.Types.GET_BENEFIT_INSTALLMENTS_INFO,
    getBenefitInstallmentsInfo.saga
  );
  yield takeLatest(
    activateBenefitInstallments.Types.ACTIVATE_BENEFIT_INSTALLMENTS,
    activateBenefitInstallments.saga
  );
  yield takeLatest(
    getPaidPayments.Types.GET_PAID_PAYMENTS,
    getPaidPayments.saga
  );

  yield takeLatest(
    getPaymentPeriods.Types.GET_PAYMENT_PERIODS,
    getPaymentPeriods.saga
  );

  yield takeLatest(
    getPaymentsByPeriod.Types.GET_PAYMENTS_BY_PERIOD,
    getPaymentsByPeriod.saga
  );

  yield takeLatest(
    getPaymentVouchers.Types.GET_PAYMENT_VOUCHERS,
    getPaymentVouchers.saga
  );
  yield takeLatest(
    generatePaymentVoucher.Types.GENERATE_PAYMENT_VOUCHER,
    generatePaymentVoucher.saga
  );
  yield takeLatest(
    generatePaymentVoucherLateFee.Types.GENERATE_PAYMENT_VOUCHER_LATE_FEE,
    generatePaymentVoucherLateFee.saga
  );
  yield takeLatest(getCaptcha.Types.GET_CAPTCHA, getCaptcha.saga);
  yield takeLatest(
    registerInsuranceValidation.Types.REGISTER_PSE,
    registerInsuranceValidation.saga
  );
  yield takeLatest(
    getClassAttendanceUseCase.Types.GET_CLASS_ATTENDANCE,
    getClassAttendanceUseCase.saga
  );
  yield takeLatest(
    getEventsByStudentScroll.Types.GET_EVENTS_BY_STUDENT_SCROLL,
    getEventsByStudentScroll.saga
  );
  yield takeLatest(
    getCoursesGradeRecord.Types.GET_COURSES_GRADE_RECORD,
    getCoursesGradeRecord.saga
  );
  yield takeLatest(
    registerEmployabilityCharter.Types.REGISTER_EMPLOYABILITY_CHARTER,
    registerEmployabilityCharter.saga
  );
  yield takeLatest(
    getSurveysValidation.Types.GET_SURVEY_VALIDATION,
    getSurveysValidation.saga
  );
  yield takeLatest(
    getEnrollmentCourses.Types.GET_ENROLLMENT_COURSES,
    getEnrollmentCourses.saga
  );
  yield takeEvery(
    getRegistrationTimes.Types.GET_REGISTRATION_TIMES,
    getRegistrationTimes.saga
  );
  yield takeLatest(
    getPeriodsWithDebtsUseCase.Types.GET_PERIODS_WITH_DEBTS,
    getPeriodsWithDebtsUseCase.saga
  );
  yield takeLatest(
    getEvaluationsToBeCorrected.Types.GET_EVALUATIONS_TO_BE_CORRECTED,
    getEvaluationsToBeCorrected.saga
  );
  yield takeLatest(
    RegisterRectificationOfGrade.Types.REGISTER_RECTIFICATION_OF_GRADE,
    RegisterRectificationOfGrade.saga
  );
  yield takeLatest(
    getProgressiveCertificationEnabled.Types
      .GET_PROGRESSIVE_CERTIFICATION_ENABLED,
    getProgressiveCertificationEnabled.saga
  );
  yield takeLatest(
    uploadValidation.Types.UPLOAD_VALIDATION,
    uploadValidation.saga
  );
  yield takeLatest(
    registerWaitingList.Types.REGISTER_WAITING_LIST,
    registerWaitingList.saga
  );
  yield takeLatest(
    eventPenalties.Types.GET_EVENT_PENALTIES,
    eventPenalties.saga
  );
  yield takeLatest(
    examsRoleByStudent.Types.GET_EXAMS_ROLE_BY_STUDENT,
    examsRoleByStudent.saga
  );
  yield takeLatest(
    unregisterWaitingList.Types.UNREGISTER_WAITING_LIST,
    unregisterWaitingList.saga
  );
  yield takeLatest(
    getUtpAdsDataUseCase.Types.GET_UTP_ADS_DATA,
    getUtpAdsDataUseCase.saga
  );
  yield takeLatest(
    getInstitutionalInformation.Types.GET_INSTITUTIONAL_INFORMATION,
    getInstitutionalInformation.saga
  );
  yield takeLatest(
    getScholarshipsDiscounts.Types.GET_SCHOLARSHIPS_DISCOUNTS,
    getScholarshipsDiscounts.saga
  );
  yield takeLatest(
    getAgreementInfo.Types.GET_AGREEMENT_INFO,
    getAgreementInfo.saga
  );
  yield takeLatest(
    getAgreementValidations.Types.GET_AGREEMENT_VALIDATIONS,
    getAgreementValidations.saga
  );
  yield takeLatest(
    registerAgreement.Types.REGISTER_AGREEMENT,
    registerAgreement.saga
  );
  yield takeLatest(
    registerReinforcementWaitingListUseCase.Types
      .REGISTER_REINFORCEMENT_WAITING_LIST,
    registerReinforcementWaitingListUseCase.saga
  );
  yield takeLatest(
    unregisterReinforcementWaitingListUseCase.Types
      .UNREGISTER_REINFORCEMENT_WAITING_LIST,
    unregisterReinforcementWaitingListUseCase.saga
  );
  yield takeLatest(getProfileAcl.Types.GET_PROFILE_ACL, getProfileAcl.saga);
  yield takeLatest(getOrganizer.Types.GET_ORGANIZER, getOrganizer.saga);
}
